import { gsap } from 'gsap/dist/gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**************************************************************
-> Animate/parallax the footer as the user scrolled
**************************************************************/
export function parallaxFooter() {
  const footer = document.querySelector('.page-footer')
  const footerContainer = document.querySelector('.footer-container')

  ScrollTrigger.matchMedia({
    // desktop
    '(min-width: 768px)': function() {
      gsap.from(footerContainer, {
    
        scrollTrigger: {
          trigger: footer,
          scrub: true,
          start: 'top bottom',
          end: 'bottom bottom',
        },
        yPercent: -25,
        ease: 'none',
      })
    },
  })

  /**************************************************************
  -> Refresh after layout change
  **************************************************************/
  $(document).on('gform_confirmation_loaded', function(){
    ScrollTrigger.refresh()
  });

}


// WEBPACK FOOTER //
// ./scripts/animation/footer.js